import FormCheckboxLabel from './FormCheckboxLabel'

export default FormCheckboxLabel
